export const queryParamsFactory = (formData, userRole) => {
	return {
		userRole,
		campaignId: formData.campaign,
		'dashboardOrganisationStructureFilter.channelId': formData.channel,
		'dashboardOrganisationStructureFilter.regionId': formData.region,
		'dashboardOrganisationStructureFilter.agencyIds': formData.agency ? [formData.agency] : undefined,
		'dashboardOrganisationStructureFilter.manager': formData.manager,
		'dashboardOrganisationStructureFilter.seller': formData.seller,
		'dashboardOrganisationStructureFilter.ppz': formData.ppz,
	};
};
